var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetracted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 5.744,
    height: 9.8,
    viewBox: "0 0 5.744 9.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_789",
    "data-name": "Rectangle 789",
    width: 5.744,
    height: 9.8
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_588",
    "data-name": "Group 588",
    transform: "translate(-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_587",
    "data-name": "Group 587",
    transform: "translate(1 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5359",
    "data-name": "Path 5359",
    d: "M5.505,8.448a.792.792,0,0,1,0,1.13.807.807,0,0,1-.581.222.807.807,0,0,1-.581-.222L.236,5.468a.791.791,0,0,1,0-1.127L4.381.228a.805.805,0,0,1,1.127,0,.791.791,0,0,1,0,1.127L1.947,4.919Z",
    transform: "translate(0 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetracted);
export default __webpack_public_path__ + "static/media/retracted.9539ea73a4419e530a2e4afb94e7bb19.svg";
export { ForwardRef as ReactComponent };